import { VODProviderType } from 'hamrah-player';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import type { FC } from 'react';
import { useCallback, useMemo } from 'react';
import { Box } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import imgProxyLoader from '@/Module/Core/Helper/imgProxyLoader';
import { usePrepareVideoSchemaObject } from '@/Module/Lesson/Hook';
import { selectedLessonSectionSelector } from '@/Module/Lesson/Store/Selector/selectedLessonSectionSelector';
import { useAppSelector } from '@/Module/Store/Hook';
import LessonDetailPlayerLimitation from './LessonDetailPlayerLimitation';
const Player = dynamic(() => import('hamrah-player').then(value => value.Player), {
  ssr: false
});
const LessonDetailPlayer: FC = () => {
  const lessonSection = useAppSelector(selectedLessonSectionSelector);
  const forceAsiatech = useAppSelector(state => state.lessonSection.forceAsiatech);
  const videoProvider = useMemo(() => {
    if (forceAsiatech) return VODProviderType.STANDARD;
    switch (lessonSection?.providerId) {
      case 1:
        return VODProviderType.POUAN;
      case 2:
        return VODProviderType.ABR_HAMRAHI;
      default:
        return VODProviderType.STANDARD;
    }
  }, [forceAsiatech, lessonSection?.providerId, lessonSection?.mediaLink]);
  const videoProviderLink = useMemo(() => {
    return videoProvider === 'STANDARD' ? lessonSection?.mediaLink || '' : lessonSection?.mediaLink2 || '';
  }, [videoProvider, lessonSection?.mediaLink, lessonSection?.mediaLink2]);
  const coverUrl = imgProxyLoader({
    src: lessonSection?.pictureUrl ?? '',
    width: 1181
  }) || `${FILE_BROWSER_URL}/img/img-lesson-section-default.webp`;
  const qualityValidator = useCallback((quality: number) => quality >= 400, []);
  const playbackRates = useMemo(() => [0.25, 0.5, 1, 1.25, 1.5, 2], []);
  const videoSchemaObject = usePrepareVideoSchemaObject();
  if (!lessonSection) return null;
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="LessonDetailPlayer.tsx">
        <script type="application/ld+json">{JSON.stringify(videoSchemaObject)}</script>
      </Head>
      <Box className="relative -mx-4 mb-4 aspect-[845/485] overflow-hidden p-0 sm:mb-2 md:mx-0 md:p-3" color="lightOrange" data-sentry-element="Box" data-sentry-source-file="LessonDetailPlayer.tsx">
        <Player vodCustomUrl={{
        [VODProviderType.ABR_HAMRAHI]: '/vod/abrehamrahi/{token}'
      }} playbackRates={playbackRates} vodType={videoProvider} playUrl={videoProviderLink} videoId={lessonSection.videoId} coverUrl={coverUrl} qualityValidate={qualityValidator} data-sentry-element="Player" data-sentry-source-file="LessonDetailPlayer.tsx">
          <LessonDetailPlayerLimitation data-sentry-element="LessonDetailPlayerLimitation" data-sentry-source-file="LessonDetailPlayer.tsx" />
        </Player>
      </Box>
    </>;
};
export default LessonDetailPlayer;